import { AutoResizableTextarea } from '@/components'
import { useReportOptions } from '@/hooks/reports/useReportOptions'
import { twMerge } from '@/styles/tailwindMergeConfig'
import { useState } from 'react'

export const reportIssuesFileIssues = {
  "invalid_geometry_in_perimeter": {
    "title": "Perímetro com geometria inválida",
    "description": "O perímetro apresenta geometrias inválidas, por favor corrija o arquivo e envie novamente."
  },
  "perimeter_and_mosaic_do_not_intersect": {
    "title": "Perímetro e ortomosaico sem intersecção",
    "description": "O perímetro não apresenta intersecção com o ortomosaico, por favor corrija o arquivo e envie novamente."
  },
  "perimeter_smaller_than_mosaic": {
    "title": "Perímetro menor que ortomosaico",
    "description": "A área do perímetro é menor que o ortomosaico. Por favor, siga com o diagnóstico se a área estiver correta ou corrija o arquivo e envie novamente."
  },
  "perimeter_bigger_than_mosaic": {
    "title": "Perímetro maior que ortomosaico",
    "description": "Perímetro maior que o ortomosaico, por favor corrija o arquivo e envie novamente."
  },
  "perimeter_displaced_from_mosaic": {
    "title": "Perímetro deslocado do ortomosaico",
    "description": "Perímetro deslocado, por favor corrija o arquivo e envie novamente."
  },
  "unrecognized_culture_in_mosaic": {
    "title": "Locais sem cultura identificada",
    "description": "O ortomosaico apresenta áreas sem cultura identificada. Por favor, siga com o diagnóstico se a área sem cultura deverá ser analisada ou corrija o arquivo e envie novamente."
  },
  "hole_in_mosaic": {
    "title": "Buraco no ortomosaico",
    "description": "Ortomosaico com buracos, por favor siga com o diagnóstico ou corrija o arquivo e envie novamente."
  },
  "duplicated_demand": {
    "title": "Demanda duplicada",
    "description": "Demanda duplicada."
  }
}

export const reportIssuesImageQuality = {
"qa_light": {
    "title": "Qualidade de Imagem - Iluminação",
    "description": "Imagens do ortomosaico com iluminação inadequada. Por favor, siga com o diagnóstico ciente que irá impactar o resultado ou cancele o processamento."
  },
  "qa_blurr": {
    "title": "Qualidade de Imagem - Borrado",
    "description": "Imagens do ortomosaico com excesso de borrado. Por favor, siga com o diagnóstico ciente que irá impactar o resultado ou cancele o processamento."
  },
  "qa_color": {
    "title": "Qualidade de Imagem - Coloração",
    "description": "Imagens do ortomosaico com coloração inadequada. Por favor, siga com o diagnóstico ciente que irá impactar o resultado ou cancele o processamento."
  },
  "qa_distortion": {
    "title": "Qualidade de Imagem - Distorção",
    "description": "Imagens do ortomosaico com distorção. Por favor, siga com o diagnóstico ciente que irá impactar o resultado ou cancele o processamento."
  }
}

export function TabsLeft() {
  const { toggleReportOptionsValue, updateReportOptions, reportOptions } = useReportOptions()
  const [localComment, setLocalComment] = useState(reportOptions.comment || '')

  const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newComment = e.target.value
    setLocalComment(newComment)
    updateReportOptions('comment', newComment)
  }

  return (
    <div className="flex flex-1 flex-col items-start gap-2">
      <div
        className={twMerge(
          'flex min-h-[400px] w-full flex-col items-start gap-4 rounded p-[18px] font-mono text-labelLarge lg:h-full',
          'bg-cromai-m3-sys-light-surface-variant text-cromai-m3-sys-light-on-background',
          'dark:bg-cromai-m3-sys-dark-surface-variant dark:text-cromai-m3-sys-dark-on-background',
          'text-[#414940] dark:text-white'
        )}
      >
        <div className="flex w-full flex-col items-start gap-4 overflow-auto">
            <h1 className='text-lg'>Problemas com Qualidade de Imagem</h1>
            {Object.entries(reportIssuesImageQuality).map(([key, value]) => (
              <label key={key} className="flex items-center gap-2">
                <input type="checkbox" value={key} className="accent-blue-500" onChange={() => toggleReportOptionsValue('reasons', {key:key, title: value.title},'key')}/>
                <span>{value.title}</span>
              </label>
            ))}
            <h1 className='text-lg'>Problemas com Arquivos</h1>
            {Object.entries(reportIssuesFileIssues).map(([key, value]) => (
              <label key={key} className="flex items-center gap-2">
                <input type="checkbox" value={key} className="accent-blue-500" onChange={() => toggleReportOptionsValue('reasons', {key:key, title: value.title},'key')}/>
                <span>{value.title}</span>
              </label>
            ))}
            <h1 className='text-lg'>Comentários Adicionais</h1>
            <AutoResizableTextarea
              className="rounded-md"
              classTextarea="w-full my-2 h-full py-2 pl-4 max-h-80 pr-40"
              value={localComment}
              onChange={handleCommentChange}
            />            
        </div>
      </div>
    </div>
  )
}
